//   action: {
//     title: string;
//     icon: string;
//     action: () => void;
//   };

export function ContentCardFooter({ children }) {
  return (
    <div className="d-flex align-items-center justify-content-end w-100 p-3">
      {children}
    </div>
  );
}
